const testimonials = [
    {
        "id": 1,
        "logo": "/testimonials/hira.png",
        "name": "Hira",
        "comment": "I'm pleased to endorse PBL Transport for supplying the XCMG XCA 160 crane for our erection project. Their professionalism and equipment quality were exceptional. The XCMG XCA 160 crane's performance and lifting capacity were instrumental in our project's success. We highly recommend PBL Transport for their outstanding support, and we look forward to future collaborations."
    },
    {
        "id": 2,
        "logo": "/testimonials/inland.png",
        "name": "Inland Work Logistics",
        "comment": "PBL handled the shipment of our cargo from Raigarh to Kanchipuram with exceptional efficiency. The cargo arrived in perfect condition and on schedule, all thanks to the highly skilled and professional team at PBL. We hope to do more business with them in the future."
    },
    {
        "id": 3,
        "logo": "/testimonials/mantena.png",
        "name": "Mantena Infrasol",
        "comment": "The cargo arrived punctually and in impeccable condition, all thanks to the proficient and dedicated PBL team. We had contacted them in the month of August for our transportation needs, they were very professional and informative. We will definitely collaborate with them in the future."
    },
    {
        "id": 4,
        "logo": "/testimonials/Rayudu.png",
        "name": "Rayudu Engineering Enterprises",
        "comment": "We rented a Manitowoc 2250 crane from PBL for our erection project. The Manitowoc 2250 crane's power and precision were pivotal in our project's success. We highly endorse PBL Transport for their exceptional support and look forward to future collaborations."
    },
    {
        "id": 5,
        "logo": "/testimonials/sfc.png",
        "name": "SFC",
        "comment": "For the shipment of my cargo from Chennai to Visakhapatnam, we used PBL Transport. The cargo was delivered on time and in perfect condition, thanks to the efficient and professional team at PBL. They were clear and prompt in their communication which goes a long way when you are doing operations across geographic locations."
    },
    {
        "id": 6,
        "logo": "/testimonials/Tera.png",
        "name": "Tera",
        "comment": "Services provided by PBL Transport Corporation Private Limited for the shipment of my cargo from Kakinada to Chennai using a 40-foot trailer. The cargo was delivered on time and in perfect condition, thanks to the efficient and professional team at PBL. I am highly satisfied with the transportation. I would definitely recommend their services to anyone looking for reliable and affordable cargo transportation solutions."
    },
    {
        "id": 7,
        "logo": "/testimonials/xlant.png",
        "name": "XLANT Infra",
        "comment": "PBL Transport's dedication to cargo safety and its high level of professionalism makes it the go-to choice for our logistical requirements. We have contracted them with many work orders for transportation and we hope to continue to do business with them in the future."
    },
    {
        "id": 8,
        "logo": "/testimonials/srisai.png",
        "name": "Sri Sai Oilfield",
        "comment": "PBL's streamlined operation throughout the process was noteworthy. I'm pleased to recommend PBL Transport for supplying the JLG 600 man-lift for our erection project. The JLG 600 man-lift's safety features and impressive reach contributed to the project's success. We highly recommend PBL Transport for its quality equipment and support, and we anticipate future collaborations."
    }
];
export default testimonials;